// extracted by mini-css-extract-plugin
export var filterIncDec = "_ax-0";
export var leftBorder = "_ax-1";
export var rightBorder = "_ax-2";
export var stringInput = "_ax-3";